import { ProjectService } from './../project.service';
import { Component, OnInit, ElementRef } from '@angular/core';

@Component({
  selector: 'app-choose-project',
  templateUrl: './choose-project.component.html',
  styleUrls: ['./choose-project.component.scss']
})
export class ChooseProjectComponent implements OnInit {
  title: string = "WYBIERZ BRYŁĘ SWOJEGO DOMU";
  subtitle: string = "Jaki styl w architekturze preferujesz – marzysz o domu klasycznym, nowoczesnym, skandynawskim, a może minimalistycznym? Wolisz dom jedno- czy dwukondygnacyjny, z płaskim czy spadzistym dachem? Wybierz projekt domu, który najlepiej odpowiada Twoim oczekiwaniom.";
  typeSelected: number =0;
  constructor(private projectService: ProjectService) { }

  ngOnInit() {
    this.projectService.resetProject();
  }
  onTypeSelect(type: number) {
    this.typeSelected = type;
  }
}
